import { RGBELoader } from 'three/addons/loaders/RGBELoader.js';
import {
  applyHdriToSceneVisual,
  getActiveViewportCamera,
  syncHdriBackgroundForCamera,
} from './ThreeJsUtils/hdriSceneBackground.js';

/** Bumped when leaving HDRI so in-flight loads can be ignored by callers. */
let hdriLoadGeneration = 0;

export function bumpHdriLoadGeneration() {
  hdriLoadGeneration += 1;
  return hdriLoadGeneration;
}

export function getHdriLoadGeneration() {
  return hdriLoadGeneration;
}

export const handleHdriSelected = (
  file,
  urll,
  rotationDegrees = 0,
  scene,
  onLoadedCallback,
  hdriVisible = true,
  camera = null,
  lightIntensity = 1
) => {
  const loadGen = hdriLoadGeneration;
  const applyHdriToScene = (envMap) => {
    // Drop stale async results after Color / Empty skybox switches.
    if (loadGen !== hdriLoadGeneration) return;

    const activeCamera = camera ?? getActiveViewportCamera();
    applyHdriToSceneVisual(
      scene,
      envMap,
      rotationDegrees,
      hdriVisible,
      activeCamera,
      null,
      lightIntensity
    );
    syncHdriBackgroundForCamera(scene, activeCamera);

    if (onLoadedCallback && typeof onLoadedCallback === 'function') {
      onLoadedCallback(envMap);
    }
  };

  if (urll) {
    new RGBELoader().load(urll, (envMap) => {
      applyHdriToScene(envMap);
    });
  } else if (file) {
    const url = URL.createObjectURL(file);
    new RGBELoader().load(url, (envMap) => {
      applyHdriToScene(envMap);
      URL.revokeObjectURL(url);
    });
  }
};
